module.exports = __webpack_public_path__ + "7a631d4eacaeffe21fcf2e2841492dff.svg";